import { LanguageConstants } from './language.constants'

const {
    FETCHING_LANGUAGE_SUCCESS,
} = LanguageConstants

// const userLocale = (locale) => ({
//   type: USER_LOCALE,
//   locale
// });

const setLanguage = (language) => {
  return dispatch => {
    dispatch({ type: FETCHING_LANGUAGE_SUCCESS, language });    
  };
}

export default {
    setLanguage,
}